import { ChangeDetectorRef, Component } from '@angular/core';
import { CommondashboardService } from './commondashboard.service';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ColumnindexmodalComponent } from '../../directives/columnindexmodal/columnindexmodal.component';
import * as Highcharts from 'highcharts';
import HC_3D from 'highcharts/highcharts-3d';
import Exporting from 'highcharts/modules/exporting';
import ExportData from 'highcharts/modules/export-data';
import OfflineExporting from 'highcharts/modules/offline-exporting';
import { PagehelpmodalService } from '../../directives/pagehelpmodal/pagehelpmodal.service';
HC_3D(Highcharts);
Exporting(Highcharts);
ExportData(Highcharts);
OfflineExporting(Highcharts);

@Component({
  selector: 'app-commondashboard',
  templateUrl: './commondashboard.component.html',
  styleUrls: ['./commondashboard.component.css']
})
export class CommondashboardComponent {
  //sameer

  registrationChartInstance!: Highcharts.Chart;
  complianceChartInstance!: Highcharts.Chart;
  contractChartInstance!: Highcharts.Chart;
  insuranceChartInstance!: Highcharts.Chart;
  assessmentChartInstance!: Highcharts.Chart;
  ifcChartInstance!: Highcharts.Chart;

  errorDIsplay = false;
  errorFromDate = false;
  errorToDate = false;
  isDateChanged = false;
  fromDate: Date | null = null;
  toDate: Date | null = null;
  compliancestatus: Array<any> = [];
  ref: DynamicDialogRef | undefined;
  titletext: string = '';
  titletextplaceholder: string = '';
  selectedChartId = ''
  isChartModal = false;

  filterdata: { fromDate: string | null; toDate: string | null } = {
    fromDate: null,
    toDate: null
  };

  labelowner: any;
  labelmanager: any;
  approvalright: any;
  insuranceapprovalflag: any;
  ancflag: any;
  requirevertlabel: any;
  vertlabelname: any;
  requirecustomerlabel: any;
  customerlabelname: any;
  islocationtype: any;
  locationtypelabel: any;

  entityarray = [];
  yeararray = [];
  statearray = [];
  locationarray = [];
  departmentarray = [];
  clientarray = [];
  verticalarray = [];
  ownerarray = [];
  managerarray = [];
  locationtypearray = [];
  lawcategoryarray = [];
  managernamearray = [];
  ownernamearray = [];

  rficircle: number;
  negocircle: number;
  activecircle: number;
  duecircle: number;
  expcircle: number;
  allcircle: number;

  knob1per: number;
  knob2per: number;
  knob3per: number;
  knob4per: number;
  knob5per: number;
  knob6per: number;

  fileSizeMB = 0;
  nccred = 0;
  ncclightred = 0;
  corange = 0;
  cgreen = 0;
  cgrey = 0;
  cpink = 0;
  nccyellow = 0;
  total = 0;
  totalonlync = 0;
  actionPercentage = 0;
  iscompint = 0;

  counttask = 0;
  countcontract = 0;
  countreg = 0;
  countltgsn = 0;
  countltgsnnotice = 0;
  countinsrnce = 0;
  countasses = 0;
  countia = 0;
  countiafind = 0;
  counthdcustmr = 0;
  counthdeslc = 0;
  counthdattach = 0;
  countifc = 0;
  counthdmnattach = 0;

  compprod = '';
  contprod = '';
  regprod = '';
  assesprod = '';
  docprod = '';
  taskprod = '';
  secprod = '';
  audprod = '';
  litprod = '';
  insprod = '';
  helprod = '';
  ifcprod = '';

  totalCompliance: number;
  totalNonCompliance: number;
  imprisonmentExposure: number;
  imprisonmentActual: number;
  licenseExposure: number;
  licenseActual: number;
  totalPenaltyExposure: string;
  totalNcExposure: string;
  totalPenaltyPaid: string;


  constructor(
    private commondashboardservice: CommondashboardService,
    private spinnerservice: NgxSpinnerService,
    private cd: ChangeDetectorRef,
    public dialogService: DialogService,
    public PagehelpmodalService: PagehelpmodalService

  ) { }

  ngOnInit() {
    this.setFinancialYearDates();
    this.fetchcomplianceconfigurationslist().then(() => {
      this.getuserxproduct();
      this.getdashboardCounts();
    });
  }

  getScoringReportFormula(type) {
    let details = {
      type: type
    };
    this.ref = this.dialogService.open(ColumnindexmodalComponent, {
      header: "Information",
      width: '51vw',
      height: 'auto',
      data: { datas: details },
    });
    this.ref.onClose.subscribe(() => {
    });
  }



  fetchcomplianceconfigurationslist(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.commondashboardservice.fetchcomplianceconfigurationslist().subscribe({
        next: (res) => {
          if (Array.isArray(res) && res.length > 0) {
            const config = res[0];
            this.labelowner = config.labelowner;
            this.labelmanager = config.labelmanager;
            this.requirevertlabel = config.requirevertlabel;
            this.vertlabelname = config.vertlabelname;
            this.requirecustomerlabel = config.requirecustomerlabel;
            this.customerlabelname = config.customerlabelname;
            this.approvalright = config.approvalright;
            this.ancflag = config.ancflag;
            this.islocationtype = config.islocationtype;
            this.locationtypelabel = config.locationtypelabel;
          }
          resolve();
        },
        error: (err) => {
          console.error('Error fetching config:', err);
          reject(err);
        }
      });
    });
  }

  getdashboardCounts() {
    this.spinnerservice.show();
    this.commondashboardservice.getdashboardCounts().subscribe({
      next: (res: any[]) => {
        const data = res[0];
        this.counttask = data.counttask ?? 0;
        this.counthdcustmr = data.counthdcustmr ?? 0;
        this.counthdeslc = data.counthdeslc ?? 0;
        this.counthdattach = data.counthdattach ?? 0;
        this.counthdmnattach = data.counthdmnattach ?? 0;
        const totalFileSize = Number(data.retvalattachmain) || 0;
        this.fileSizeMB = Math.round((totalFileSize / 1_000_000) * 100) / 100;
      },
      error: (err) => {
        this.spinnerservice.hide();
        console.error(err);
      }
    });
  }
  getuserxproduct() {
    this.spinnerservice.show();
    this.commondashboardservice.getuserxproduct().subscribe({
      next: (res: any[]) => {
        this.spinnerservice.hide();
        res.forEach(item => {
          const prodname = item.productinitial;
          if (prodname === 'Compliance') { this.compprod = 'Compliance'; }
          if (prodname === 'Contract') { this.contprod = 'Contract'; }
          if (prodname === 'Registration') { this.regprod = 'Registration'; }
          if (prodname === 'Assessment') { this.assesprod = 'Assessment'; }
          if (prodname === 'Documents') { this.docprod = 'Documents'; }
          if (prodname === 'Task') { this.taskprod = 'Task'; }
          if (prodname === 'Secretarial') { this.secprod = 'Secretarial'; }
          if (prodname === 'Audit') { this.audprod = 'Audit'; }
          if (prodname === 'Litigation') { this.litprod = 'Litigation'; }
          if (prodname === 'Insurance') { this.insprod = 'Insurance'; }
          if (prodname === 'Helpdesk') { this.helprod = 'Helpdesk'; }
          if (prodname === 'IFC') { this.ifcprod = 'IFC'; }
        });
        if (this.compprod === 'Compliance') {
          this.loadComplianceStatusPieChart(this.filterdata);
          this.getriskreport();
        }
        if (this.regprod === 'Registration') {
          this.loadRegistrationStatusPieChart(this.filterdata);
        }

        if (this.contprod === 'Contract') {
          this.loadContractStatusPieChart(this.filterdata);
        }

        if (this.insprod === 'Insurance') {
          this.loadinsauranceStatusPieChart(this.filterdata);
        }

        if (this.assesprod === 'Assessment') {
          this.loadassessmentStatusPieChart(this.filterdata);
        }

        if (this.ifcprod === 'IFC') {
          this.loadifcStatusPieChart(this.filterdata);
        }

        if (this.litprod === 'Litigation') {
          this.loadlitigationStatusPieChart();
          this.loadnoticeStatusPieChart();
        }

        if (this.audprod === 'Audit') {
          this.loadAuditStatusPieChart(this.filterdata);
          this.loadAuditobservcationStatusPieChart();
        }
      },
      error: (err) => {
        this.spinnerservice.hide();
        console.error(err);
      }
    });
  }

  getriskreport() {
    this.spinnerservice.show();
    this.commondashboardservice.getRiskreportData(this.filterdata).subscribe({
      next: (res) => {
        this.spinnerservice.hide();
        const data = res[0];
        this.totalCompliance = Number(data.totalcompliance);
        this.totalNonCompliance = Number(data.noncompliance);
        const compImp = Number(data.compliancewithimprisonment);
        const ncImp = Number(data.noncompliancewithimprisonment);
        this.imprisonmentExposure =
          (ncImp > 0 && compImp > 0)
            ? Math.round((ncImp / compImp) * 100 * 100) / 100
            : 0;
        this.imprisonmentActual = Number(data.imprisonmenthappened);
        const compLic = Number(data.compliancewithlicense);
        const ncLic = Number(data.noncompliancewithlicense);
        this.licenseExposure =
          (ncLic > 0 && compLic > 0)
            ? Math.round((ncLic / compLic) * 100 * 100) / 100
            : 0;
        this.licenseActual = Number(data.licensecancelled);
        this.totalPenaltyExposure = this.formatPenalty(Number(data.totalmaxpenalty));
        this.totalNcExposure = this.formatPenalty(Number(data.noncompliancemaxpenalty));
        this.totalPenaltyPaid = this.formatPenalty(Number(data.totalpenaltypaid));
      },
      error: (err) => {
        this.spinnerservice.hide();
        console.error(err);
      }
    });
  }

  formatPenalty(value: number): string {
    if (!value || isNaN(value)) return '0';
    if (value > 99 && value < 100000) {
      return Math.floor(value).toString();
    }
    if (value > 99999 && value < 10000000) {
      return (Math.round((value / 100000) * 100) / 100) + 'L';
    }
    if (value >= 10000000) {
      return (Math.round((value / 10000000) * 100) / 100) + 'Cr';
    }
    return value.toString();
  }

  formatToCrore(value: number): string {
    if (!value) return '0Cr';
    return (value / 10000000).toFixed(2) + 'Cr';
  }

  loadComplianceStatusPieChart(filterdata: any) {
    this.spinnerservice.show();
    const compliancestatuschartdata = this.commondashboardservice.getcompliancestatusdata(filterdata);
    compliancestatuschartdata.subscribe(
      res => {
        this.spinnerservice.hide();
        this.compliancestatus = res;
        let duecount = 0;
        let noncomplianceount = 0;
        let anccount = 0;
        let pendingapprovalcount = 0;
        let ontimecount = 0;
        let lateclosercount = 0;
        let notapplicablecount = 0;
        this.iscompint = 0;
        this.compliancestatus.map(item => {
          this.iscompint += Number(item.internalCount || 0);
          switch (item.countStatus) {
            case 'DUE':
              duecount = item.count;
              break;
            case 'Non Compliance':
              noncomplianceount = item.count;
              break;
            case 'ANC':
              anccount = item.count;
              break;
            case 'Pending Approval':
              pendingapprovalcount = item.count;
              break;
            case 'On Time':
              ontimecount = item.count;
              break;
            case 'Late Closer':
              lateclosercount = item.count;
              break;
            case 'Not Applicable':
              notapplicablecount = item.count;
              break;
          }
        });
        let subtitleText = '';

        if (this.fromDate && this.toDate) {
          subtitleText = `From ${this.formatDate(this.fromDate, 'DD-MMM-YYYY')} 
                  to ${this.formatDate(this.toDate, 'DD-MMM-YYYY')}`;
        } else if (this.fromDate) {
          subtitleText = `From ${this.formatDate(this.fromDate, 'DD-MMM-YYYY')}`;
        } else if (this.toDate) {
          subtitleText = `Up to ${this.formatDate(this.toDate, 'DD-MMM-YYYY')}`;
        }
        if (this.ancflag === 'N') {
          noncomplianceount = noncomplianceount + anccount;
          anccount = 0;
        }

        this.nccred = noncomplianceount;
        this.ncclightred = anccount;
        this.nccyellow = duecount;
        this.cgreen = ontimecount;
        this.corange = lateclosercount;
        this.cgrey = notapplicablecount;
        this.cpink = this.approvalright === 'Y' ? pendingapprovalcount : 0;

        this.total = this.nccred + this.nccyellow + this.cgreen + this.corange + this.cgrey + this.cpink + anccount;
        this.totalonlync = this.nccred + this.cgreen + this.corange + this.cgrey + this.cpink;
        if (this.total > 0) {
          const usageTotal =
            this.cgreen +
            this.corange +
            this.cgrey +
            this.cpink;
          this.actionPercentage = Number(
            ((usageTotal / this.totalonlync) * 100).toFixed(2)
          );
        } else {
          this.actionPercentage = 0;
        }

        this.cd.detectChanges();
        const chartData: [string, number][] = [];
        const chartColors: string[] = [];

        if (noncomplianceount > 0) {
          chartData.push(['Non Compliance', noncomplianceount]);
          chartColors.push('#ff4d4d');
        }

        if (this.ancflag === 'Y' && anccount > 0) {
          chartData.push(['Accepted NonCompliance', anccount]);
          chartColors.push('#873939');
        }

        if (lateclosercount > 0) {
          chartData.push(['Late Closure', lateclosercount]);
          chartColors.push('#FFC200');
        }

        if (ontimecount > 0) {
          chartData.push(['On Time', ontimecount]);
          chartColors.push('#5ce65c');
        }

        if (duecount > 0) {
          chartData.push(['Due', duecount]);
          chartColors.push('#ffff00');
        }

        if (notapplicablecount > 0) {
          chartData.push(['Not Applicable', notapplicablecount]);
          chartColors.push('#8a8a8a');
        }

        if (this.approvalright === 'Y' && pendingapprovalcount > 0) {
          chartData.push(['Pending Approval', pendingapprovalcount]);
          chartColors.push('#FF69B4');
        }
        if (this.complianceChartInstance) {
          this.complianceChartInstance.destroy();
        }
        this.complianceChartInstance = Highcharts.chart('compliancePie', {
          accessibility: { enabled: false },
          chart: {
            type: 'pie',
            options3d: { enabled: true, alpha: 45, beta: 0 },
            animation: true
          },
          title: {
            useHTML: true,
            text: 'Compliance Status',
            style: { fontSize: '20px', },
            margin: 35
          },
          subtitle: {
            text: subtitleText,
            style: {
              fontSize: '13px',
              color: '#666',
            },
            align: 'center'
          },
          credits: { enabled: false },
          colors: chartColors,

          tooltip: {
            pointFormat: '{point.y}',
            borderWidth: 2,
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
          },
          plotOptions: {
            pie: {
              allowPointSelect: true,
              cursor: 'pointer',
              depth: 35,
              showInLegend: true
            }
          },
          series: [
            {
              type: 'pie',
              name: 'Number',
              data: chartData,
              dataLabels: { enabled: true, format: '{point.name}: {point.y}' },
              point: {
                events: {
                  click: (event) => {
                    // this.openModal('piechart', '', event.point.options);
                  }
                }
              }
            }
          ],
          exporting: {
            enabled: true,
          }
        });

        this.commondashboardservice.setChartInstance('compliancePie', this.complianceChartInstance);
      },
      error => {
        const timestamp = new Date().toLocaleString();
        this.spinnerservice.hide();
        Swal.fire({
          title: error.error?.error || 'Error',
          text: `This event occurred at: ${timestamp}`,
          icon: 'error'
        });
      }
    );
  }

  loadRegistrationStatusPieChart(filterdata: any) {
    this.spinnerservice.show();
    const piechartdata = this.commondashboardservice.getRegistrationPiechart(filterdata);
    piechartdata.subscribe(res => {
      this.spinnerservice.hide();
      let countstatusA = 0;
      let countstatusD = 0;
      let countstatusE = 0;
      let countstatusAF = 0;
      let countstatusIP = 0;
      let countstatusNA = 0;
      let countstatusAR = 0;
      let countstatusAP = 0;

      res.map(e => {
        if (e.status == "AV") countstatusA = e.ctr;
        else if (e.status == "REN") countstatusD = e.ctr;
        else if (e.status == "EXP") countstatusE = e.ctr;
        else if (e.status == "AF") countstatusAF = e.ctr;
        else if (e.status == "IP") countstatusIP = e.ctr;
        else if (e.status == "AR") countstatusAR = e.ctr;
        else if (e.status == "AP") countstatusAP = e.ctr;
        else countstatusNA += e.ctr;
      });

      const pieData = [
        {
          name: 'Active',
          y: countstatusA > 0 ? countstatusA : null,
          dataLabels: { enabled: countstatusA > 0 }
        },
        {
          name: 'Due For Renewal',
          y: countstatusD > 0 ? countstatusD : null,
          dataLabels: { enabled: countstatusD > 0 }
        },
        {
          name: 'Expired',
          y: countstatusE > 0 ? countstatusE : null,
          dataLabels: { enabled: countstatusE > 0 }
        },
        {
          name: 'Applied For',
          y: countstatusAF > 0 ? countstatusAF : null,
          dataLabels: { enabled: countstatusAF > 0 }
        },
        {
          name: 'In Process',
          y: countstatusIP > 0 ? countstatusIP : null,
          dataLabels: { enabled: countstatusIP > 0 }
        },
        {
          name: 'Not Applicable',
          y: countstatusNA > 0 ? countstatusNA : null,
          sliced: true,
          selected: true,
          dataLabels: { enabled: countstatusNA > 0 }
        }
      ];
      this.countreg = pieData.reduce((sum, item) =>
        sum + (typeof item.y === 'number' ? item.y : 0), 0
      );
      this.registrationChartInstance = Highcharts.chart('registrationPie', {
        accessibility: {
          enabled: false
        },
        chart: {
          type: 'pie',
          options3d: { enabled: true, alpha: 45, beta: 0 },
          animation: true
        },
        title: {
          useHTML: true,
          text: 'Registration Status',
          style: { fontSize: '20px' },
          margin: 35
        },
        subtitle: {
          text: 'Overall Data',
          style: {
            fontSize: '13px',
            color: '#666',
          },
          align: 'center'
        },
        credits: {
          enabled: false
        },
        colors: ['rgb(128, 232, 114)', 'rgb(242, 242, 33)', 'rgb(255, 77, 77)', 'rgb(187, 118, 236)', 'rgb(154, 209, 226)', 'rgb(196, 203, 240)'],
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            depth: 35,
            showInLegend: true,
            dataLabels: {
              enabled: true,
              format: '{point.name}: {point.y}'
            },
            point: {
              events: {
                click: (event: any) => {
                  let status = '';
                  if (event.point.options.name == "Active") {
                    status = 'active';
                  } else {
                    status = event.point.options.name.toLowerCase();
                  }
                  let name = `Registration/License Status- ${event.point.options.name}`;
                  // this.openModal(event.point.y, name, status, 'registrationstatus');
                }
              }
            }
          },
          column: {
            stacking: 'normal',
            dataLabels: {
              enabled: false,
              color: 'white',
              style: { textShadow: '0 0 2px grey', cursor: 'pointer' }
            }
          }
        },
        tooltip: {
          useHTML: true,
          formatter: function () {
            return `<div style="text-align: left;">
                  <div style="font-weight: normal;">${this.point.name}</div>
                  <div style="font-weight: bold;">${this.point.y}</div>
                </div>`;
          },
          borderWidth: 2,
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
        },
        series: [{
          name: 'Number',
          type: 'pie',
          data: pieData
        }],
        lang: {
          customButtonTooltip: 'Change title of pie chart before exporting it'
        } as any,
        exporting: {
          chartOptions: {
            chart: {
              width: 1600,
              height: 800,
              spacingLeft: 40,
              spacingRight: 40,
              spacingTop: 5,
              spacingBottom: 5
            },
            title: {
              style: {
                fontSize: '28px !important',
                fontWeight: 'bold',
                color: '#000'
              },
              margin: 40
            },
            xAxis: {
              labels: {
                rotation: 0,
                style: {
                  fontSize: '10px',
                  fontWeight: 'bold',
                  color: '#000'
                }
              }
            },
            yAxis: {
              title: {
                text: 'Registration Status',
                style: {
                  fontSize: '20px',
                  color: '#000'
                }
              },
              labels: {
                style: {
                  fontSize: '9px',
                  fontWeight: 'bold'
                }
              },
              stackLabels: {
                style: {
                  fontSize: '8px'
                }
              }
            },
            legend: {
              itemStyle: {
                fontWeight: 'bold',
                fontSize: '10px'
              }
            },
            plotOptions: {
              column: {
                dataLabels: {
                  style: {
                    fontSize: '9px'
                  }
                }
              }
            }
          },
        },
      });

      this.commondashboardservice.setChartInstance('registrationPie', this.complianceChartInstance);

    }, error => {
      const timestamp = new Date().toLocaleString();
      Swal.fire({
        title: error.error.error,
        text: `This event occurred at: ${timestamp}`,
        icon: 'error'
      });
    });
  }

  loadContractStatusPieChart(filterdata: any) {
    this.spinnerservice.show();
    const piechartdata = this.commondashboardservice.contractpiechart(filterdata);
    piechartdata.subscribe(data => {
      this.spinnerservice.hide();
      let tobeexecuted = 0;
      let activecount = 0;
      let dueforrenewal = 0;
      let expired = 0;

      data.forEach(e => {
        const isNotExtended = e.CT_ISEXTENDED === 'N';
        const isNotRenewed = e.ct_isrenewed === 'N';
        const isNotArchived = e.CT_ISARCHIVED === 'N';
        const isNotFinalOrSubmitted = (e.CT_ISFINALLYSUBMITTED === 'N' || e.CT_ISFINALLYSUBMITTED === 'S') && e.CT_ISFINALLYAPPROVED === 'N';
        const isNotTerminated = e.ct_isterminated === 'N';
        const isFinallyApproved = e.CT_ISFINALLYAPPROVED === 'Y';
        const ct_iscontractlive = e.ct_iscontractlive === 'Y';

        const hiaDate = new Date(e.hia);
        const expiryDate = new Date(e.expirydate);
        const today = new Date();

        if (isNotExtended && isNotRenewed && isNotArchived && isNotFinalOrSubmitted) {
          tobeexecuted++;
        }

        const isRenewedNotExpired = isNotRenewed && hiaDate >= today;
        const isRenewedAndNotExpired = e.ct_isrenewed === 'Y' && expiryDate >= today;

        if (isNotTerminated && (isRenewedNotExpired || isRenewedAndNotExpired) && isNotExtended && isNotArchived && isFinallyApproved) {
          activecount++;
        }

        const isHiaPassed = hiaDate <= today;
        const isExpiryFutureOrToday = expiryDate >= today;

        if (isNotTerminated && isNotRenewed && isHiaPassed && isExpiryFutureOrToday && isNotExtended && isNotArchived && isFinallyApproved) {
          dueforrenewal++;
        }

        const isExpired = expiryDate < today;

        if (isNotTerminated && isNotRenewed && isExpired && isNotExtended && isNotArchived && isFinallyApproved && ct_iscontractlive) {
          expired++;
        }
      });

      const pieData: any[] = [];
      const pieColors: string[] = [];

      if (tobeexecuted > 0) {
        pieData.push(['To Be Executed', tobeexecuted]);
        pieColors.push('#ba4bc6');
      }

      if (activecount > 0) {
        pieData.push(['Active', activecount]);
        pieColors.push('#80e872');
      }

      if (dueforrenewal > 0) {
        pieData.push(['Due For Renewal', dueforrenewal]);
        pieColors.push('#f2f221');
      }

      if (expired > 0) {
        pieData.push(['Expired', expired]);
        pieColors.push('#ff4d4d');
      }
      this.countcontract = pieData.reduce(
        (sum, item) => sum + (Array.isArray(item) ? item[1] : 0),
        0
      );
      this.contractChartInstance = Highcharts.chart('contractPie', {
        accessibility: { enabled: false },
        chart: {
          type: 'pie',
          options3d: {
            enabled: true,
            alpha: 45,
            beta: 0
          }
        },
        title: {
          useHTML: true,
          text: '<span class="highcharts-custom-title">Contract Status</span>'
        },
        subtitle: {
          text: 'Overall Data',
          style: {
            fontSize: '13px',
            color: '#666',
          },
          align: 'center'
        },
        credits: { enabled: false },
        colors: pieColors,
        legend: {
          itemStyle: {
            color: '#000000'
          }
        },

        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            depth: 35,
            showInLegend: true,
          }
        },

        lang: {
          customButtonTooltip: 'Change title of Contract Status chart before exporting it'
        } as any,

        series: [{
          name: 'Contracts',
          data: pieData,
          dataLabels: {
            enabled: true,
            useHTML: true,
            formatter: function () {
              return `<span style="font-weight:bold;">${this.point.name}: ${this.point.y}</span>`;
            }
          },
          type: 'pie',
        }],
        exporting: {
          chartOptions: {
            chart: {
              width: 1600,
              height: 800,
              spacingLeft: 40,
              spacingRight: 40,
              spacingTop: 5,
              spacingBottom: 5
            },
            title: {
              style: {
                fontSize: '28px !important',
                fontWeight: 'bold',
                color: '#000'
              },
              margin: 40
            },
            xAxis: {
              labels: {
                rotation: -45,
                style: {
                  fontSize: '10px',
                  fontWeight: 'bold',
                  color: '#000'
                }
              }
            },
            yAxis: {
              title: {
                text: 'Contract Status',
                style: {
                  fontSize: '20px',
                  color: '#000'
                }
              },
              labels: {
                style: {
                  fontSize: '9px',
                  fontWeight: 'bold'
                }
              },
              stackLabels: {
                style: {
                  fontSize: '8px'
                }
              }
            },
            legend: {
              itemStyle: {
                fontWeight: 'bold',
                fontSize: '10px'
              }
            },
            plotOptions: {
              column: {
                dataLabels: {
                  style: { fontSize: '9px' }
                }
              }
            }
          },
        },
        tooltip: {
          useHTML: true,
          formatter: function () {
            return `
          <div style="text-align:left;">
            <div style="font-weight:bold;">${this.point.name}</div>
            <div style="font-weight:bold;">${this.point.y}</div>
          </div>`;
          },
          borderWidth: 2,
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
        }
      });
      this.commondashboardservice.setChartInstance('contractPie', this.contractChartInstance);
    }, error => {
      const timestamp = new Date().toLocaleString();
      Swal.fire({
        title: error.error?.error || 'Error',
        text: `This event occurred at: ${timestamp}`,
        icon: 'error'
      });
    });
  }

  loadinsauranceStatusPieChart(filterdata: any) {
    this.commondashboardservice.getinsuranceapprovalflag().subscribe(res => {
      this.insuranceapprovalflag = res?.[0]?.keyvalue || 'N';
    });
    let inprocessdatacount = 0;
    let negotiationdatacount = 0;
    let activedatacount = 0;
    let expireddatacount = 0;
    let dueforrenewaldatacount = 0;
    let dataarr = [];
    this.commondashboardservice.getpoliciescount(filterdata).subscribe((data: any) => {
      if (data.length > 0) {
        inprocessdatacount = data[0].ip;
        negotiationdatacount = data[0].nego;
        activedatacount = data[0].act
        expireddatacount = data[0].exp
        dueforrenewaldatacount = data[0].due;
        this.rficircle = data[0].ip;
        this.negocircle = data[0].nego;
        this.activecircle = data[0].act;
        this.duecircle = data[0].due;
        this.expcircle = data[0].exp;
        this.allcircle = data[0].arc;
      }
      else {
        inprocessdatacount = 0;
        negotiationdatacount = 0;
        activedatacount = 0;
        expireddatacount = 0;
        dueforrenewaldatacount = 0;
        this.rficircle = 0;
        this.negocircle = 0;
        this.activecircle = 0;
        this.duecircle = 0;
        this.expcircle = 0;
        this.allcircle = 0;

      }
      let pieData = [];

      if (this.insuranceapprovalflag === 'Y') {
        pieData = [
          { name: 'Active', y: activedatacount, color: '#5ce65c' },
          { name: 'Due For Renewal', y: dueforrenewaldatacount, color: '#fbfb08' },
          { name: 'Expired', y: expireddatacount, color: '#ff4d4d' },
          { name: 'Negotiaton Stage', y: negotiationdatacount, color: '#f57ca5' },
          { name: 'Request For Insurance', y: inprocessdatacount, color: '#9AD1E2' },
        ];

      } else {
        pieData = [
          { name: 'Active', y: activedatacount, color: '#5ce65c' },
          { name: 'Due For Renewal', y: dueforrenewaldatacount, color: '#fbfb08' },
          { name: 'Expired', y: expireddatacount, color: '#ff4d4d' },
        ];

      }

      this.countinsrnce = pieData.reduce(
        (sum, item) => sum + (item.y > 0 ? item.y : 0),
        0
      );
      let total = 0;

      if (data && data.length > 0) {
        const item = data[0];
        total =
          (item.arc || 0) +
          (item.act || 0) +
          (item.nego || 0) +
          (item.due || 0) +
          (item.ip || 0) +
          (item.exp || 0);
      }
      let k1 = (this.rficircle / total) * 100;
      this.knob1per = Math.round(k1 * 100) / 100;
      let k2 = (this.negocircle / total) * 100;
      this.knob2per = Math.round(k2 * 100) / 100;
      let k3 = (this.activecircle / total) * 100;
      this.knob3per = Math.round(k3 * 100) / 100;
      let k4 = (this.duecircle / total) * 100;
      this.knob4per = Math.round(k4 * 100) / 100;
      let k5 = (this.expcircle / total) * 100;
      this.knob5per = Math.round(k5 * 100) / 100;

      Highcharts.chart('insurancepie', {
        tooltip: {
          pointFormat: '<b>{point.y}</b>',
          borderWidth: 2,
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
        },
        accessibility: { enabled: false },
        chart: {
          type: 'pie', options3d: {
            enabled: true,
            alpha: 45, beta: 0
          }
        },
        title: {
          useHTML: true,
          text: 'Insurance Status',
          style: {
            fontSize: '20px',
          }
        },
        subtitle: {
          text: 'Overall Data',
          style: {
            fontSize: '13px',
            color: '#666',
          },
          align: 'center'
        },
        credits: {
          enabled: false
        },

        plotOptions: {
          pie: { allowPointSelect: true, cursor: 'pointer', depth: 35, showInLegend: true },
          column: {
            stacking: 'normal', dataLabels: {
              enabled: false,
              color: ('white'),
              style: { textShadow: '0 0 3px ', cursor: 'pointer' }
            }
          },
        },

        series: [
          {
            name: 'Number',
            data: pieData,
            dataLabels: {
              enabled: true,
              format: '{point.name}: {point.y}' // Display name and value with one decimal place
            },
            type: 'pie',
            point: {
              events: {
                click: (event: any) => {
                  let status = event.point.options.name.toLowerCase();
                  let finalstatus = '';
                  if (status == 'due for renewal') { finalstatus = 'dueforrenewal' }
                  if (status == 'request for insurance') { finalstatus = 'inprocess' }
                  if (status == 'negotiaton stage') { finalstatus = 'negotiation' }
                  if (status == 'active') { finalstatus = 'active' }
                  if (status == 'expired') { finalstatus = 'expired' }
                  //this.openinsauranceModal(event.point.y, event.point.options.name, finalstatus, 'insurancestatus');

                }
              },
            },
          },
        ],
        exporting: {
          enabled: true,
          buttons: {

          }
        },
      },);
      this.commondashboardservice.setChartInstance('insurancepie', this.insuranceChartInstance);
    }, error => {
      const timestamp = new Date().toLocaleString(); // example timestamp
      Swal.fire({
        title: error.error.error,
        text: `This event occurred at: ${timestamp}`,
        icon: 'error'
      });
    });
  }

  loadassessmentStatusPieChart(filterdata: any) {
    this.spinnerservice.show();
    this.commondashboardservice.getassessmentPiechart(filterdata).subscribe((data: any) => {
      let open = 0;
      let closed = 0;
      let hearing = 0;
      let reply = 0;

      if (data && data.length > 0) {
        data.forEach(item => {
          if (item.noticestatus === '1') {
            //alert(" item.ctr"+ item.ctr);
            open = item.ctr;
          }
          else if (item.noticestatus === '2') {
            closed = item.ctr;
          }
          else if (item.noticestatus === '3') {
            hearing = item.ctr;
          }
          else if (item.noticestatus === '4') {
            reply = item.ctr;
          }
        });
      }
      else {
        open = 0;
        closed = 0;
        hearing = 0;
        reply = 0;
      }
      const pieData = [
        { name: 'Open', y: open },
        { name: 'Closed', y: closed },
      ];

      this.countasses = pieData.reduce(
        (sum, item) => sum + (item.y > 0 ? item.y : 0),
        0
      );


      Highcharts.chart('assessmentpie', {
        tooltip: {
          pointFormat: '<b>{point.y}</b>',
          borderWidth: 2,
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
        },
        accessibility: {
          enabled: false
        },
        chart: {
          type: 'pie',
          options3d: {
            enabled: true,
            alpha: 45,
            beta: 0
          }
        },
        title: {
          useHTML: true,
          text: 'Assessment Status'
        },
        subtitle: {
          text: 'Overall Data',
          style: {
            fontSize: '13px',
            color: '#666',
          },
          align: 'center'
        },
        credits: {
          enabled: false
        },

        colors: ['#FFFF00', '#7ef7a2'],
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            depth: 35,
            showInLegend: true
          },
          column: {
            stacking: 'normal', dataLabels: {
              enabled: false,
              color: ('white'),
              style: { textShadow: '0 0 2px grey', cursor: 'pointer' }
            }
          },
        },

        series: [
          {
            name: '',
            data: pieData,
            dataLabels: {
              enabled: true,
              format: '{point.name}: {point.y}'
            },
            type: 'pie',
            point: {
              events: {
                click: (event) => {
                }
              },
            },
          },
        ],
        exporting: {
          enabled: true,
        },
      },
      );

    }, error => {
      const timestamp = new Date().toLocaleString(); // example timestamp
      Swal.fire({
        title: error.error.error,
        text: `This event occurred at: ${timestamp}`,
        icon: 'error'
      });
    });
  }

  loadifcStatusPieChart(filterdata: any) {
    this.spinnerservice.show();
    const piechartdata = this.commondashboardservice.riskpichart(filterdata);
    piechartdata.subscribe(res => {
      this.spinnerservice.hide();

      let high = 0;
      let medium = 0;
      let low = 0;
      res.map(e => {
        if (e.risklevel === 'H') { high++; }
        if (e.risklevel === 'M') { medium++; }
        if (e.risklevel === 'L') { low++; }

      });
      const pieData = [
        { name: 'High', y: high },
        { name: 'Medium', y: medium },
        { name: 'Low', y: low }
      ];
      this.countifc = pieData.reduce(
        (sum, item) => sum + (item.y > 0 ? item.y : 0),
        0
      );
      let subtitleText = '';

      if (this.fromDate && this.toDate) {
        subtitleText = `From ${this.formatDate(this.fromDate, 'DD-MMM-YYYY')} 
                  to ${this.formatDate(this.toDate, 'DD-MMM-YYYY')}`;
      } else if (this.fromDate) {
        subtitleText = `From ${this.formatDate(this.fromDate, 'DD-MMM-YYYY')}`;
      } else if (this.toDate) {
        subtitleText = `Up to ${this.formatDate(this.toDate, 'DD-MMM-YYYY')}`;
      }

      this.ifcChartInstance = Highcharts.chart('ifcpie', {
        accessibility: {
          enabled: false
        },
        chart: {
          type: 'pie',
          options3d: {
            enabled: true,
            alpha: 45,
            beta: 0
          }
        },
        title: {
          useHTML: true,
          text: 'IFC Risk Level Graph'
        },
        subtitle: {
          text: subtitleText,
          style: {
            fontSize: '13px',
            color: '#666',
          },
          align: 'center'
        },
        credits: {
          enabled: false
        },
        colors: ['#ff4d4d', '#f56e6e', '#f7a5a5'],
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            depth: 35,
            showInLegend: true
          },
        },
        lang: {
          customButtonTooltip: 'Change title of Risk Level graph before exporting it'
        } as any,
        series: [
          {
            name: 'IFC',
            data: pieData,
            dataLabels: {
              enabled: true,
              format: '{point.name}: {point.y}'
            },
            type: 'pie',
          },
        ],
        exporting: {
          enabled: true,
        },
        tooltip: {
          useHTML: true,
          formatter: function () {
            return `<div style="text-align: left;">
<div style="font-weight: normal;">${this.point.name}</div>
<div style="font-weight: bold;">${this.point.y}</div>
</div>`;
          },
          borderWidth: 2,
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
        },
      });
      this.commondashboardservice.setChartInstance('ifcpie', this.ifcChartInstance);
    },
      error => {
        const timestamp = new Date().toLocaleString();
        this.spinnerservice.hide();
        Swal.fire({
          title: error.error.error,
          text: `This event occurred at: ${timestamp}`,
          icon: 'error'
        });
      });
  }

  loadnoticeStatusPieChart() {
    this.spinnerservice.show();
    const piechartdata =
      this.commondashboardservice.getnoticestatuswisebarchart(this.filterdata);
    piechartdata.subscribe(res => {
      this.spinnerservice.hide();
      let countOpen = 0;
      let countClosed = 0;
      let countInProcess = 0;
      let countOnHold = 0;
      let countSettled = 0;
      let countAbeyance = 0;
      let totalOpen = 0;
      res.map(e => {
        if (e.noticestatus == 1) {
          countOpen = e.ctr;
        } else if (e.noticestatus == 2) {
          countAbeyance = e.ctr;
        } else if (e.noticestatus == 3) {
          countClosed = e.ctr;
        } else if (e.noticestatus == 4) {
          countOnHold = e.ctr;
        } else if (e.noticestatus == 5) {
          countInProcess = e.ctr;
        } else if (e.noticestatus == 6) {
          countSettled = e.ctr;
        } else {
          totalOpen += e.ctr;
        }
      });
      const pieData = [
        { name: 'Open', y: countOpen, sliced: true, selected: true },
        { name: 'Abeyance', y: countAbeyance },
        { name: 'Closed', y: countClosed },
        { name: 'OnHold', y: countOnHold },
        { name: 'InProcess', y: countInProcess },
        { name: 'Settled', y: countSettled }
      ];
      this.countltgsnnotice = pieData.reduce(
        (sum, item) => sum + (item.y > 0 ? item.y : 0),
        0
      );
      const chartInstancepie = Highcharts.chart('noticepi', {
        tooltip: {
          pointFormat: '<b>{point.y}</b>',
          borderWidth: 2,
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
        },
        accessibility: {
          enabled: false
        },
        chart: {
          type: 'pie',
          options3d: {
            enabled: true,
            alpha: 45,
            beta: 0
          }
        },
        credits: {
          enabled: false
        },
        title: {
          useHTML: true,
          text: 'Notice Status',
        }, subtitle: {
          text: 'Overall Data',
          style: {
            fontSize: '13px',
            color: '#666',
          },
          align: 'center'
        },
        colors: [
          '#FFFF00',
          '#ffc107',
          '#5ce65c',
          '#f47ca4',
          '#61b3f5',
          '#153650'
        ],

        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            depth: 35,
            showInLegend: true
          },
          column: {
            stacking: 'normal',
            dataLabels: {
              enabled: false,
              color: 'white',
              style: { textShadow: '0 0 2px grey', cursor: 'pointer' }
            }
          }
        },

        series: [
          {
            name: 'Number',
            type: 'pie',
            data: pieData,
            dataLabels: {
              enabled: true,
              format: '{point.name}: {point.y}'
            }
          }
        ],

        exporting: {
          enabled: true,
          menuItemDefinitions: {
            printHeader: {
              text: 'Print Chart',
              onclick: function () { }
            }
          }
        }
      });
      this.commondashboardservice.setChartInstance(
        'noticepi',
        chartInstancepie
      );

    }, error => {
      const timestamp = new Date().toLocaleString();
      Swal.fire({
        title: error.error.error,
        text: `This event occurred at: ${timestamp}`,
        icon: 'error'
      });
    });
  }

  loadlitigationStatusPieChart() {
    this.spinnerservice.show();
    const payload =
      this.isDateChanged && (this.fromDate || this.toDate)
        ? this.filterdata
        : {};
    const casestatuspiechartdata = this.commondashboardservice.getcasestatuspiechart(payload);
    casestatuspiechartdata.subscribe(res => {
      this.spinnerservice.hide();
      let countopen = 0;
      let countclose = 0;
      let totalOpen1 = 0;
      //  WSA open
      res.map(e => {

        if (e.closedflag == 'N') {
          countopen = e.ctr
        }
        else if (e.closedflag == 'Y') {
          countclose = e.ctr
        }

        else { totalOpen1 += e.ctr; }
      })
      this.countltgsn = 0;
      if (countopen > 0) this.countltgsn += countopen;
      if (countclose > 0) this.countltgsn += countclose;
      const chartInstancepie = Highcharts.chart('litigationpie', {
        tooltip: {
          pointFormat: '<b>{point.y}</b>',
          borderWidth: 2,
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
        },
        accessibility: {
          enabled: false
        },
        chart: {
          type: 'pie',
          options3d: {
            enabled: true,
            alpha: 45,
            beta: 0
          }
        },
        title: {
          useHTML: true,
          text: 'Litigation Status'
        },
        subtitle: {
          text: 'Overall Data',
          style: {
            fontSize: '13px',
            color: '#666',
          },
          align: 'center'
        },
        credits: {
          enabled: false
        },
        colors: ['#FFFF00', '#5ce65c'], plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            depth: 35,
            showInLegend: true,
            size: '80%',
          },
          column: {
            stacking: 'normal', dataLabels: {
              enabled: false,
              color: ('white'),
              style: { textShadow: '0 0 2px grey', cursor: 'pointer' }
            }
          },
        },
        series: [
          {
            name: 'Number',
            data: [
              ['Open', countopen],
              ['Closed', countclose],
            ],
            dataLabels: {
              enabled: true,
              format: '{point.name}: {point.y}'
            },
            type: 'pie',
            point: {
              events: {
                click: (event: any) => {
                  let status = ''
                  if (event.point.options.name == "Open (IP+PA+AP)") {
                    status = 'open'
                  }
                  else { status = event.point.options.name.toLowerCase() }
                }
              },
            },
          },
        ],
        exporting: {
          enabled: true,
          menuItemDefinitions: {
            printHeader: {
              text: 'Print Chart',
              onclick: function () { }
            }
          }
        },

      },
      );
      this.commondashboardservice.setChartInstance('litigationpie', chartInstancepie);
    }, error => {
      const timestamp = new Date().toLocaleString();
      Swal.fire({
        title: error.error.error,
        text: `This event occurred at: ${timestamp}`,
        icon: 'error'
      });
    });
  };

  loadAuditStatusPieChart(filterdata: any) {
    this.spinnerservice.show();
    const auditStatusPie$ = this.commondashboardservice.getauditPiechart(filterdata);
    auditStatusPie$.subscribe(
      (res: any[]) => {
        this.spinnerservice.hide();

        let countOpen = 0;
        let countCompleted = 0;
        let countClosed = 0;
        let countAbandoned = 0;
        let countSuspended = 0;
        let countPostponed = 0;

        res.map(e => {
          if (e.status === 'C') {
            countCompleted = e.ctr;
          }
          else if (e.status === 'Z') {
            countClosed = e.ctr;
          }
          else if (e.status === 'H') {
            countAbandoned = e.ctr;
          }
          else if (e.status === 'I') {
            countSuspended = e.ctr;
          }
          else if (e.status === 'J') {
            countPostponed = e.ctr;
          }
          else if (e.status === 'A' || e.status === 'S' || e.status === 'W') {
            countOpen += e.ctr;
          }
        });
        const pieData = [
          { name: 'Open(IP+PA+AP)', y: countOpen },
          { name: 'Completed', y: countCompleted },
          { name: 'Closed', y: countClosed },
          { name: 'Abandoned', y: countAbandoned },
          { name: 'Suspended', y: countSuspended },
          { name: 'Postponed', y: countPostponed }
        ];
        this.countia = pieData.reduce(
          (sum, item) => sum + (item.y > 0 ? item.y : 0),
          0
        );
        const chartInstancepie = Highcharts.chart('auditpie', {
          tooltip: {
            pointFormat: '<b>{point.y}</b>',
            borderWidth: 2,
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
          },

          accessibility: {
            enabled: false
          },

          chart: {
            type: 'pie',
            options3d: {
              enabled: true,
              alpha: 45,
              beta: 0
            }
          },

          title: {
            useHTML: true,
            text: 'Audit Status'
          },
          subtitle: {
            text: 'Overall Data',
            style: {
              fontSize: '13px',
              color: '#666',
            },
            align: 'center'
          },
          credits: {
            enabled: false
          },

          colors: [
            '#f7f77e', // Open
            '#7ef7a2', // Completed
            '#8bc34a', // Closed
            '#FF5733', // Abandoned
            '#DE3163', // Suspended
            '#808000'  // Postponed
          ],
          plotOptions: {
            pie: {
              allowPointSelect: true,
              cursor: 'pointer',
              depth: 35,
              showInLegend: true,
              size: '80%'
            }
          },

          series: [{
            name: 'Number',
            type: 'pie',
            data: pieData,
            dataLabels: {
              enabled: true,
              format: '{point.name}: {point.y}'
            },
            point: {
              events: {
                click: (event: any) => {
                  let status = '';
                  if (event.point.options.name === 'Open') {
                    status = 'open';
                  } else {
                    status = event.point.options.name.toLowerCase();
                  }
                }
              }
            }
          }]
        });

        this.commondashboardservice.setChartInstance('auditpie', chartInstancepie);
      },
      error => {
        this.spinnerservice.hide();
        const timestamp = new Date().toLocaleString();
        Swal.fire({
          title: error.error?.error || 'Error',
          text: `This event occurred at: ${timestamp}`,
          icon: 'error'
        });
      }
    );
  }

  loadAuditobservcationStatusPieChart() {
    this.spinnerservice.show();
    this.commondashboardservice.getObsStatusChart().subscribe({
      next: (data) => {
        this.spinnerservice.hide();
        let countstatusC = 0;
        let totalOpen = 0;
        if (data && data.length > 0) {
          totalOpen = Number(data[0]?.open) || 0;
          countstatusC = Number(data[1]?.closed) || 0;
        }
        this.countiafind = totalOpen + countstatusC;
        const chartInstancepie = Highcharts.chart('obsstatuspie', {
          accessibility: {
            enabled: false
          },
          chart: {
            type: 'pie',
            options3d: {
              enabled: true,
              alpha: 45,
              beta: 0
            },
            animation: true
          },
          title: {
            useHTML: true,
            text: 'Observation Status',
            style: {
              fontSize: '16px',
              fontWeight: 'bold'
            },
            margin: 40
          },
          credits: { enabled: false },
          colors: ['rgb(255,235,59)', 'rgb(32,178,170)'],
          tooltip: {
            useHTML: true,
            formatter: function () {
              return `<div style="text-align: left;">
                  <div style="font-weight: normal;">${this.point.name}</div>
                  <div style="font-weight: bold;">${this.point.y}</div>
                </div>`;
            },
            borderWidth: 2,
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
          },
          plotOptions: {
            pie: {
              allowPointSelect: true,
              cursor: 'pointer',
              depth: 35,
              showInLegend: true
            },
            column: {
              stacking: 'normal', dataLabels: {
                enabled: false,
                color: ('white'),
                style: { textShadow: '0 0 2px grey', cursor: 'pointer' }
              }
            },
          },

          series: [
            {
              data: [
                ['Open', totalOpen],
                {
                  name: 'Closed',
                  y: countstatusC,
                  sliced: true,
                  selected: true
                },

              ],
              dataLabels: {
                enabled: true,
                format: '{point.name}: {point.y}' // Display name and value with one decimal place
              },
              type: 'pie',
            },

          ],
        },
        );
        this.commondashboardservice.setChartInstance('obsstatuspie', chartInstancepie);
      }, error: (error) => {
        this.spinnerservice.hide();
        const timestamp = new Date().toLocaleString(); // example timestamp
        Swal.fire({
          title: error.error.error,
          text: `This event occurred at: ${timestamp}`,
          icon: 'error'
        });
      }

    });
  }


  validateDates() {
    this.errorFromDate = false;
    this.errorToDate = false;
    this.errorDIsplay = false;
    this.isDateChanged = true;
    if (!this.fromDate) {
      this.errorFromDate = true;
      return;
    }
    if (!this.toDate) {
      this.errorToDate = true;
      return;
    }
    if (this.fromDate > this.toDate) {
      this.errorDIsplay = true;
      return;
    }
    this.filterdata.fromDate = this.formatToApiDate(this.fromDate);
    this.filterdata.toDate = this.formatToApiDate(this.toDate);
    if (this.compprod === 'Compliance') {
      this.loadComplianceStatusPieChart(this.filterdata);
      this.getriskreport();
    }
    if (this.ifcprod === 'IFC') {
      this.loadifcStatusPieChart(this.filterdata);
    }
  }

  formatToApiDate(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  refreshFilters() {
    this.errorDIsplay = false;
    this.errorFromDate = false;
    this.errorToDate = false;
    this.setFinancialYearDates();
  }

  getdatetooltip() {
    if (!this.fromDate) {
      return 'Select From Date';
    }
    return this.formatDate(this.fromDate, 'DD-MMM-YYYY');
  }

  formatDate(date: Date, format: string): string {
    const d = new Date(date);
    const day = d.getDate().toString().padStart(2, '0');
    const month = d.toLocaleString('en-US', { month: 'short' });
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  }

  setFinancialYearDates() {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1;
    let fyStart: Date;
    let fyEnd: Date;
    if (month >= 4) {
      fyStart = new Date(year, 3, 1);
      fyEnd = new Date(year + 1, 2, 31);
    } else {
      fyStart = new Date(year - 1, 3, 1);
      fyEnd = new Date(year, 2, 31);
    }
    this.fromDate = fyStart;
    this.toDate = fyEnd;
    this.filterdata.fromDate = this.formatToApiDate(fyStart);
    this.filterdata.toDate = this.formatToApiDate(fyEnd);
  }

}
